{
  "min": -23,
  "max": 246,
  "R": [0, 44, 255, 255, 255],
  "G": [0, 128, 90, 255, 255],
  "B": [0, 0, 70, 0, 255],
  "A": [0, 0, 82, 184, 228],
  "I": [0, 64, 131, 196, 255]
}
